import React from 'react'
import './../App.css'
import { Route, Switch, Redirect } from 'react-router-dom'
import Logo from './x43mk2-logo.svg'
import Start from './Start'
import Hull from './Hull'
import Bowsprit from './Bowsprit'
import Hulltreatment from './Hulltreatment'
import Deck from './Deck'
import BathingPlatform from './BathingPlatform'
import Transom from './Transom'
import MastAndBoom from './MastAndBoom'
import Wheels from './Wheels'
import CockpitTable from './CockpitTable'
import Sprayhood from './Sprayhood'
import Surfaces from './Surfaces'
import Saloon from './Saloon'
import Galley from './Galley'
import OwnersCabin from './OwnersCabin'
import AftCabin from './AftCabin'
import Heads from './Heads'
import Summary from './Summary'

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg'
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg'
import hullColor13 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg'
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg'
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg'

import deckOption1 from '../assets/deck/modernteak.jpg'
import deckOption2 from '../assets/deck/flexiteek.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg'
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg'

import veneer1 from '../assets/interiorColors/nordic_oak.jpg'
import veneer2 from '../assets/interiorColors/teak.jpg'

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg'
import laminate2 from '../assets/interiorColors/walnut.jpg'
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'
import { withTranslation } from 'react-i18next'

import ConfiguratorContainer from '../ConfiguratorContainer'

class X43MK2Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x4-3/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & Light Grey (RAL 7035) Waterlines'
        ),
        preview: hullColor11
      },
      {
        value: 2,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & Black Grey (RAL 7021) Waterlines'
        ),
        preview: hullColor12
      },
      {
        value: 3,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & Dark Blue (RAL 5011) Waterlines'
        ),
        preview: hullColor13
      },
      {
        value: 4,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & Pure White (RAL 9010) Waterlines'
        ),
        preview: hullColor14
      },
      {
        value: 5,
        label: this.props.t('Black Grey'),
        description: this.props.t(
          '(RAL 7021) & Pure White (RAL 9010) Waterlines'
        ),
        preview: hullColor15
      }
    ]

    this.BowSpritOptions = [
      {
        value: 1,
        label: this.props.t('Hull color bow sprit'),
        description: this.props.t('(will match hull color)')
      }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Black') },
      { value: 3, label: this.props.t('Copper') }
    ]

    this.DeckOptions = [
      {
        value: 1,
        label: this.props.t('Genuine teak with black caulkings'),
        preview: deckOption1
      },
      {
        value: 2,
        label: this.props.t('Flexiteek with grey stripes'),
        preview: deckOption2
      }
    ]

    this.BathingPlatformOptions = [
      { value: 1, label: this.props.t('No bathing platform') },
      {
        value: 2,
        label: this.props.t('Bathing platform'),
        description: this.props.t(
          'Foldable with mechanical hoisting system and attachment point for separate bathing ladder.'
        )
      }
    ]

    this.BoomCoverOptions = [
      { value: 1, label: this.props.t('None'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]

    this.WheelOptions = [
      { value: 1, label: this.props.t('Steel wheel') },
      { value: 2, label: this.props.t('Composite wheel black') },
      { value: 3, label: this.props.t('Composite wheel white') }
    ]

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Aluminium') },
      { value: 3, label: this.props.t('White painted carbon') },
      { value: 4, label: this.props.t('Black painted carbon') },
      { value: 2, label: this.props.t('Clear coated carbon') }
    ]

    this.VeneerOptions = [
      {
        value: 1,
        label: this.props.t('Nordic oak (standard)'),
        thumbnail: veneer1
      },
      {
        value: 2,
        label: this.props.t('Modern teak (optional)'),
        thumbnail: veneer2
      }
    ]

    this.FloorboardOptions = [
      {
        value: 1,
        label: this.props.t('Teak laminate (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t('Walnut laminate (optional)'),
        thumbnail: laminate2
      },
      {
        value: 3,
        label: this.props.t('Teak with inlay stripes / holly (optional)'),
        thumbnail: laminate3
      }
    ]

    this.CupboardsSaloonOptions = [
      { value: 1, label: this.props.t('Standard') }
    ]

    this.HandrailOptions = [
      { value: 3, label: this.props.t('Stainless steel') },
      { value: 2, label: this.props.t('Wooden laminated') }
    ]

    this.WorktopOptions = [
      {
        value: 1,
        label: this.props.t('Worktop in Camoan white Corian'),
        thumbnail: galley1
      },
      {
        value: 2,
        label: this.props.t('Worktop in black quartz Corian'),
        thumbnail: galley2
      }
    ]

    this.AftCabinLayoutOptions = [
      { value: 1, label: this.props.t('') },
      { value: 2, label: this.props.t('Upper shelves') },
      { value: 3, label: this.props.t('Freeboard hung sea berths') }
    ]

    this.FabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless – 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.SprayhoodOptions = [
      { value: 2, label: this.props.t('None'), thumbnail: sprayhood1 },
      { value: 3, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 4, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 5, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 6, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]

    const defaultHullColour = this.HullColourOptions[0]
    const defaultTransomColor = this.getTransomColorByHullColourValue(
      defaultHullColour.value
    )

    this.state = Object.assign(this.state, {
      boat: 'X43MK2',
      exterior: {
        HullColour: defaultHullColour,
        BowSprit: this.BowSpritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        Deck: this.DeckOptions[0],
        TeakOnSideDecks: { value: 1, label: 'false' },
        TeakOnCoachroof: { value: 1, label: 'false' },
        BathingPlatform: this.BathingPlatformOptions[0],
        TeakOnBathingPlatform: { value: 1, label: 'false' },
        Wheel: this.WheelOptions[0],
        MastAndBoom: this.MastAndBoomOptions[0],
        BoomCover: this.BoomCoverOptions[0],
        CockpitTable: { value: 1, label: 'false' },
        SelfTacker: { value: 1, label: 'false' },
        Sprayhood: this.SprayhoodOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 175,
          color: defaultTransomColor,
          value: 'My yacht',
          font: this.fontOptions[0],
          size: this.sizeOptions[2],
          horizontalOffset: -36
        },
        Port: {
          verticalOffset: 366,
          color: defaultTransomColor,
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[1],
          horizontalOffset: -50
        }
      },
      interior: {
        Veneer: this.VeneerOptions[0],
        Floorboard: this.FloorboardOptions[0],
        Handrail: this.HandrailOptions[0],
        Worktop: this.WorktopOptions[0],
        Fabric: this.FabricOptions[0],
        CupboardsSaloon: { value: 1, label: 'true' },
        CupboardsOwnersCabin: { value: 1, label: 'false' },
        FabricOwnersCabin: this.FabricOptions[0],
        FabricAftCabin: this.FabricOptions[0],
        AftCabinLayout: this.AftCabinLayoutOptions[0],
        Mast: this.MastAndBoomOptions[0]
      }
    })

    this.steps = [
      { name: this.props.t('Start'), url: '/x43mk2/start' },
      { name: this.props.t('Hull'), url: '/x43mk2/hull' },
      { name: this.props.t('Bowsprit'), url: '/x43mk2/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/x43mk2/hulltreatment' },
      { name: this.props.t('Deck'), url: '/x43mk2/deck' },
      {
        name: this.props.t('Bathing platform'),
        url: '/x43mk2/bathingplatform'
      },
      { name: this.props.t('Transom'), url: '/x43mk2/transom' },
      { name: this.props.t('Mast and Boom'), url: '/x43mk2/mastboom' },
      { name: this.props.t('Steering wheels'), url: '/x43mk2/wheels' },
      { name: this.props.t('Cockpit Table'), url: '/x43mk2/cockpittable' },
      {
        name: this.props.t('Sprayhood and Boomcover'),
        url: '/x43mk2/sprayhood'
      },
      { name: this.props.t('Interior surfaces'), url: '/x43mk2/surfaces' },
      { name: this.props.t('Saloon fabric'), url: '/x43mk2/saloon' },
      { name: this.props.t('Galley'), url: '/x43mk2/galley' },
      { name: this.props.t('Owners Cabin'), url: '/x43mk2/ownerscabin' },
      { name: this.props.t('Aft Cabin'), url: '/x43mk2/aftcabin' },
      { name: this.props.t('Heads'), url: '/x43mk2/heads' },

      { name: this.props.t('Summary'), url: '/x43mk2/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    const transomColor = this.getTransomColorByHullColourValue(
      newConfiguration.HullColour.value
    )
    transom.Name.color = transomColor
    transom.Port.color = transomColor

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  getTransomColorByHullColourValue (hullColourValue) {
    switch (hullColourValue) {
      case 1:
        return this.colorOptions[6]
      case 2:
        return this.colorOptions[6]
      case 3:
        return this.colorOptions[6]
      case 4:
      case 5:
        return this.colorOptions[1]
      default:
        return this.colorOptions[4]
    }
  }

  handleExteriorConfigurationChange (newConfiguration) {
    let interior = this.state.interior
    interior.Mast = newConfiguration.MastAndBoom

    super.handleInteriorConfigurationChange(interior)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  generateCode () {
    let data = []
    data.push('x43mk2')

    data.push([])
    let exterior = this.state.exterior
    for (const key in exterior) {
      if (exterior.hasOwnProperty(key)) {
        let element = exterior[key].value
        data[data.length - 1].push(element)
      }
    }

    data.push([])
    data[data.length - 1].push([])
    data[data.length - 1].push([])

    let transom = this.state.transom
    data[data.length - 1][0].push(transom.Name.value)
    data[data.length - 1][0].push(transom.Name.font.value)
    data[data.length - 1][0].push(transom.Name.size.value)
    data[data.length - 1][0].push(transom.Name.color.value)
    data[data.length - 1][0].push(transom.Name.horizontalOffset)
    data[data.length - 1][0].push(transom.Name.verticalOffset)

    data[data.length - 1][1].push(transom.Port.value)
    data[data.length - 1][1].push(transom.Port.font.value)
    data[data.length - 1][1].push(transom.Port.size.value)
    data[data.length - 1][1].push(transom.Port.color.value)
    data[data.length - 1][1].push(transom.Port.horizontalOffset)
    data[data.length - 1][1].push(transom.Port.verticalOffset)

    data.push([])
    let interior = this.state.interior
    for (const key in interior) {
      if (interior.hasOwnProperty(key)) {
        let element = interior[key].value
        data[data.length - 1].push(element)
      }
    }

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'x43mk2') {
      return
    }

    let exterior = this.state.exterior
    exterior.HullColour =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.BowSprit =
      this.BowSpritOptions.find(v => v.value === json[1][1]) ||
      this.BowSpritOptions[0]
    exterior.HullTreatment =
      this.HullTreatmentOptions.find(v => v.value === json[1][2]) ||
      this.HullTreatmentOptions[0]
    exterior.Deck =
      this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0]
    exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' }
    exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' }
    exterior.BathingPlatform =
      this.BathingPlatformOptions.find(v => v.value === json[1][6]) ||
      this.BathingPlatformOptions[0]
    exterior.TeakOnBathingPlatform = { value: +json[1][7] || 1, label: '' }
    exterior.Wheel =
      this.WheelOptions.find(v => v.value === json[1][9]) ||
      this.WheelOptions[0]
    exterior.MastAndBoom =
      this.MastAndBoomOptions.find(v => v.value === json[1][10]) ||
      this.MastAndBoomOptions[0]
    exterior.BoomCover =
      this.BoomCoverOptions.find(v => v.value === json[1][11]) ||
      this.BoomCoverOptions[0]
    exterior.CockpitTable = { value: +json[1][13] || 1, label: '' }
    exterior.SelfTacker = { value: +json[1][14] || 1, label: '' }
    exterior.SprayHood =
      this.SprayhoodOptions.find(v => v.value === json[1][8]) ||
      this.SprayhoodOptions[0]

    let transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    let interior = this.state.interior
    interior.Veneer =
      this.VeneerOptions.find(v => v.value === json[3][0]) ||
      this.VeneerOptions[0]
    interior.Floorboard =
      this.FloorboardOptions.find(v => v.value === json[3][1]) ||
      this.FloorboardOptions[0]
    interior.Handrail =
      this.HandrailOptions.find(v => v.value === json[3][2]) ||
      this.HandrailOptions[0]
    interior.Worktop =
      this.WorktopOptions.find(v => v.value === json[3][3]) ||
      this.WorktopOptions[0]
    interior.Fabric =
      this.FabricOptions.find(v => v.value === json[3][4]) ||
      this.FabricOptions[0]
    interior.CupboardsSaloon = { value: +json[3][5] || 1, label: '' }
    interior.CupboardsOwnersCabin = { value: +json[3][6] || 1, label: '' }
    interior.FabricOwnersCabin =
      this.FabricOptions.find(v => v.value === json[3][7]) ||
      this.FabricOptions[0]
    interior.FabricAftCabin =
      this.FabricOptions.find(v => v.value === json[3][8]) ||
      this.FabricOptions[0]
    interior.AftCabinLayout =
      this.AftCabinLayoutOptions.find(v => v.value === json[3][9]) ||
      this.AftCabinLayoutOptions[0]

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route
          exact
          path='/x43mk2'
          render={() => <Redirect to='/x43mk2/start' />}
        />
        <Route
          path='/x43mk2/start'
          render={props => (
            <Start
              {...props}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
            />
          )}
        />
        <Route
          path='/x43mk2/hull'
          render={props => (
            <Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/bowsprit'
          render={props => (
            <Bowsprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowSpritOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/hulltreatment'
          render={props => (
            <Hulltreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/deck'
          render={props => (
            <Deck
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              deckOptions={this.DeckOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/bathingplatform'
          render={props => (
            <BathingPlatform
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              bathingPlatformOptions={this.BathingPlatformOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/transom'
          render={props => (
            <Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/mastboom'
          render={props => (
            <MastAndBoom
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              mastAndBoomOptions={this.MastAndBoomOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/wheels'
          render={props => (
            <Wheels
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              wheelOptions={this.WheelOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/cockpittable'
          render={props => (
            <CockpitTable
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
            />
          )}
        />
        <Route
          path='/x43mk2/sprayhood'
          render={props => (
            <Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              SprayhoodOptions={this.SprayhoodOptions}
              BoomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/surfaces'
          render={props => (
            <Surfaces
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              veneerOptions={this.VeneerOptions}
              floorboardOptions={this.FloorboardOptions}
              handrailOptions={this.HandrailOptions}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x43mk2/saloon'
          render={props => (
            <Saloon
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x43mk2/galley'
          render={props => (
            <Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              worktopOptions={this.WorktopOptions}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x43mk2/ownerscabin'
          render={props => (
            <OwnersCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x43mk2/aftcabin'
          render={props => (
            <AftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              configuration={this.state.interior}
              aftCabinOptions={this.AftCabinLayoutOptions}
            />
          )}
        />
        <Route
          path='/x43mk2/heads'
          render={props => (
            <Heads
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x43mk2/summary'
          render={props => (
            <Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(X43MK2Container)



// WEBPACK FOOTER //
// ./src/X43MK2/X43MK2Container.js